import { AUDIO_TYPES } from './upload';

export function checkIsAudioFile(file: File) {
  return AUDIO_TYPES.some((type) => file.type.startsWith(type));
}

/**
 * 检测文件后缀是否为音频格式
 * @param suffix 文件后缀名（如 'mp3', 'wav' 等）
 * @returns 是否为音频格式
 */
export function isAudioFileSuffix(suffix: string): boolean {
  const audioSuffixes = ['mp3', 'wav', 'wave', 'm4a', 'mpeg'];
  return audioSuffixes.includes(suffix.toLowerCase());
}

// 歌词行接口
export interface LyricLine {
  time: number; // 时间戳（秒）
  text: string; // 歌词文本
}

// 解析歌词字符串为结构化数据
export const parseLyrics = (lyricsInput: string): LyricLine[] => {
  // 支持多重时间标签（如 [01:18.77][01:45.49]text），分多行
  const lyricLines: LyricLine[] = [];
  // 分割成每一行
  const lines = lyricsInput.split('\n');
  const timeReg = /\[(\d{2}):(\d{2}\.\d{2})\]/g;

  for (const line of lines) {
    let result: RegExpExecArray | null;
    const currentTimes: number[] = [];
    const text = line.replace(timeReg, '').trim();

    // 提取所有时间标签
    while ((result = timeReg.exec(line)) !== null) {
      const [, min, sec] = result;
      currentTimes.push(parseInt(min, 10) * 60 + parseFloat(sec));
    }

    for (const time of currentTimes) {
      lyricLines.push({ time, text });
    }
    timeReg.lastIndex = 0;
  }

  // 按时间排序
  return lyricLines.sort((a, b) => a.time - b.time);
};
